import { render } from "./NavLayout.vue?vue&type=template&id=01a11460"
import script from "./NavLayout.vue?vue&type=script&lang=js"
export * from "./NavLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__